/**
 * documentSets constants
 */
export const DOCUMENTS_LOAD_REQUESTED = 'DOCUMENTS_LOAD_REQUESTED';
export const DOCUMENTS_LOAD_SUCCEEDED = 'DOCUMENTS_LOAD_SUCCEEDED';
export const DOCUMENTS_LOAD_FAILED = 'DOCUMENTS_LOAD_FAILED';
export const DOCUMENTS_LOAD_CANCELED = 'DOCUMENTS_LOAD_CANCELED';

export const DOCUMENTS_MERGE = 'DOCUMENTS_MERGE';

export const DOCUMENTS_SET = 'DOCUMENTS_SET';
